import type { JSX } from 'react';
import { Col, FormGroup, FormParagraph, Row } from '@ksyos/design-system';
import { v4 } from 'uuid';
import type { JSONValue } from '@common/interfaces';

type FormGroupRowAndColsWithFormParagraphProps = Readonly<{
    label: string;
    values: Array<JSONValue>;
}>;

export function FormGroupRowAndColsWithFormParagraph(props: FormGroupRowAndColsWithFormParagraphProps): JSX.Element {
    const { values, label } = props;

    return (
        <FormGroup label={label}>
            <Row columnGap={8}>
                {values.map((value) => {
                    if (typeof value !== 'string') {
                        return null;
                    }

                    return (
                        <Col key={v4()}>
                            <FormParagraph>{value}</FormParagraph>
                        </Col>
                    );
                })}
            </Row>
        </FormGroup>
    );
}
